export const SET_COLLABORATORS = 'SET_COLLABORATORS';
export const DELETE_COLLABORATOR = 'DELETE_COLLABORATOR';
export const EDIT_COLLABORATOR = 'EDIT_COLLABORATOR';
export const ADD_COLLABORATOR = 'ADD_COLLABORATOR';
